export const getOtherPlayersStyles = (theme) => ({
  container: {
    padding: "20px",
    backgroundColor: theme.background,
    minHeight: "100vh",
  },
  header: {
    textAlign: "center",
    marginBottom: "30px",
    paddingBottom: "20px",
    borderBottom: `2px solid ${theme.border}`,
  },
  title: {
    color: theme.text,
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "8px",
  },
  subtitle: {
    color: theme.textSecondary,
    fontSize: "16px",
  },
  searchContainer: {
    marginBottom: "30px",
    maxWidth: "600px",
    margin: "0 auto 30px",
  },
  searchInputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    color: theme.textSecondary,
    pointerEvents: "none",
  },
  searchInput: {
    width: "100%",
    padding: "12px 40px 12px 44px",
    fontSize: "14px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    transition: "border-color 0.3s ease",
    outline: "none",
  },
  clearButton: {
    position: "absolute",
    right: "12px",
    background: "none",
    border: "none",
    color: theme.textSecondary,
    cursor: "pointer",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
  },
  playersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "20px",
    marginBottom: "30px",
  },
  playerCard: {
    backgroundColor: theme.surface,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "16px",
    transition: "all 0.3s ease",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    boxShadow: `0 2px 4px ${theme.textSecondary}10`,
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: `0 4px 8px ${theme.textSecondary}20`,
      borderColor: theme.primary,
    },
  },
  imageContainer: {
    width: "100%",
    height: "320px",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: theme.background,
    position: "relative",
  },
  playerImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  imagePlaceholder: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.background,
    border: `1px dashed ${theme.border}`,
    borderRadius: "8px",
  },
  placeholderText: {
    marginTop: "8px",
    fontSize: "12px",
    color: theme.textSecondary,
  },
  playerInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  playerName: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "4px",
  },
  playerDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginTop: "8px",
  },
  detailRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    color: theme.text,
  },
  playerMeta: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginTop: "8px",
    paddingTop: "8px",
    borderTop: `1px solid ${theme.border}`,
  },
  noCharacterContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem",
    textAlign: "center",
    minHeight: "400px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    margin: "20px",
  },
  noCharacterTitle: {
    color: theme.text,
    marginTop: "1rem",
    marginBottom: "0.5rem",
  },
  noCharacterText: {
    color: theme.textSecondary,
    maxWidth: "400px",
  },
  noSessionContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem",
    textAlign: "center",
    minHeight: "400px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    margin: "20px",
  },
  noSessionTitle: {
    color: theme.text,
    marginTop: "1rem",
    marginBottom: "0.5rem",
  },
  noSessionText: {
    color: theme.textSecondary,
    maxWidth: "400px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem",
    minHeight: "400px",
  },
  loadingText: {
    marginTop: "1rem",
    color: theme.textSecondary,
    fontSize: "16px",
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem",
    textAlign: "center",
    minHeight: "400px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.error}40`,
    margin: "20px",
  },
  errorTitle: {
    color: theme.error,
    marginTop: "1rem",
    marginBottom: "0.5rem",
  },
  errorText: {
    color: theme.textSecondary,
    marginBottom: "1rem",
  },
  retryButton: {
    padding: "8px 16px",
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "opacity 0.2s ease",
  },
  noResults: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem",
    minHeight: "300px",
    color: theme.textSecondary,
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem",
    textAlign: "center",
    minHeight: "400px",
  },
  emptyStateTitle: {
    color: theme.text,
    marginTop: "1rem",
    marginBottom: "0.5rem",
  },
  emptyStateText: {
    color: theme.textSecondary,
    maxWidth: "400px",
  },
});
